<template lang="pug">
  div()
    app-header(:white='true' class='u-bg-primary')

    //- figure(class='u-m0'  data-aos="fade-down")
      img(src='/images/report.jpg' class='u-block u-12/12')

    div(class="u-bg-border u-pt3")
      div(class='o-wrapper u-pt4 u-flex u-justify-between' id='reports-container')
        section(class='u-8/12@laptop u-7/12@tablet u-12/12 u-mb4')
          article(v-for='report in reports' class='c-post u-mb4 u-11/12@tablet u-12/12' data-aos='fade-up' )
            progressive-background(:src='report.imageUrl' class='c-post__image', :placeholder='report.imageThumbUrl')
            div(class='u-p4 u-bg-white')
              router-link(:to="{ name: 'Report', params:{slug: report.slug}}" class='c-post__title u-fz-h3') {{report.title}}
              div(v-html='report.content' class="u-my3")
              p(class='')
                router-link(:to="{ name: 'Report', params:{slug: report.slug}}" class='u-color-secondary') Leer más...
              p(class='u-mb0 u-right-align u-capitalize u-color-dark u-fw-s-bold') {{report.date | date('short')}}

          nav(class='u-flex u-justify-between u-items-center' v-if='reports.length > 0 && totalPages != 1')
            button(class="c-btn c-btn--tertiary u-p2 u-fz-h4", :disabled='currentPage === 1' @click="prevReports" v-scroll-to="'#reports-container'")
              i(class='u-icon') arrow_left
            ul(class='u-flex u-mt0 u-mb0 u-px2 u-flex-wrap' v-if='totalPages > 0')
              li(class='u-px1' v-for='number in totalPages')
                button(@click="changePage(number)" v-scroll-to="'#reports-container'" class="u-fw-s-bold u-px1", :class="{'u-color-primary' : currentPage === number}")  {{number}}
            button(class="c-btn c-btn--tertiary u-p2 u-fz-h4", :disabled='totalPages === currentPage' @click="nextReports" v-scroll-to="'#reports-container'")
              i(class='u-icon') arrow_right

        aside(class='u-4/12@laptop u-5/12@tablet u-12/12 u-mb5 u-show@tablet' style='padding-top: 3.85rem;')
          div(class='u-px4  u-py3 u-bg-primary u-br8 u-mb4')
            figure(class='u-m0 u-5/12 u-border u-border-white u-mb3 u-circle u-border-8 u-mx-auto' style='margin-top: -5rem;')
              img(src='/images/report.png')

            h3(class='u-center u-fz-h3 u-mt0 u-mb3 u-pt2')
              span(class='u-color-secondary') - Reporta&nbsp;
              span(class='u-white') Aquí -
            form(@submit.prevent='postForm')
              input-validate(
                v-model='form.dni', :rule='rules.dni' icon='card' placeholder='DNI', :validation='toggleValidate'
                wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
              input-validate(
                v-model='form.cellphone', :rule='rules.cellphone' icon='cellphone' placeholder='Celular o teléfono', :validation='toggleValidate'
                wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
              input-validate(
                v-model='form.title', :rule='rules.title' icon='message' placeholder='Título del reporte', :validation='toggleValidate'
                wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
              datepicker(
                :calendar-button='true' calendar-button-icon='u-icon calendar' placeholder='Fecha de reporte'
                language='es' class='c-input c-input--icon u-mb3' format='dd MMMM yyyy' v-model='currentDate')
              file-validate(type='file' @update='updateFile', :clear='clearForm'
                :rule='rules.photo.extension' icon='photo' placeholder='Foto', :validation='toggleValidate'
                wrapper-class='c-input c-input--icon' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')
              input-validate(
                v-model='form.detail' type='textarea', :rule='rules.detail' placeholder='Detalles del reporte', :validation='toggleValidate'
                wrapper-class='c-input' class='u-mb3 u-12/12' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
              div(class='u-mb3')
                button(class='c-btn--primary u-12/12 u-fw-s-bold u-fz-h4', :disabled='isLoading') Enviar

          div(class='u-bg-white u-py3 u-px4 u-br8')
            h3(class='u-center u-fz-h4 u-mt0')
              span(class='u-block u-color-secondary') ¿Qué es
              span(class='u-block u-color-primary') Reporta Pavill?

            div(v-html='company.pavillReport' class='u-mt3')
    button(class='c-btn--primary u-fw-s-bold u-fz-h4 c-btn--fixed u-hide@tablet' @click='isShowModalReport = true') Reportar aquí
    app-footer(:show-info='false')
    loading(message='Enviando' v-if='isLoading')
    modal-report(v-if='isShowModalReport' @hide='isShowModalReport = false' @loading='isLoading = !isLoading' @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-confirm(v-if='isShowModalConfirm' @hide='isShowModalConfirm = false' message='Tu reporte ha sido registrado correctamente.')
    modal-error(v-if='isShowModalError' @hide='isShowModalError = false')
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import Validator from 'validatorjs'
  import ModalReport from './ModalReport'

  export default {
    name: 'ReportsScreen',
    components: {
      ModalReport
    },
    data () {
      return {
        reports: [],
        isShowModalReport: false,
        isShowModalError: false,
        isShowModalConfirm: false,
        isLoading: false,
        toggleValidate: false,
        formValidate: false,
        clearForm: false,
        currentDate: '',
        currentPage: 1,
        totalPages: 1,
        lastPage: 1,
        form: {
          dni: '',
          cellphone: '',
          title: '',
          date: '',
          detail: '',
          // recaptcha: '',
          photo: {
            base64: '',
            extension: ''
          }
        },
        rules: {
          dni: 'required',
          title: 'required',
          date: 'required',
          detail: 'required',
          photo: {
            extension: 'required'
          },
          // recaptcha: 'required'
          cellphone: 'required|phone'
        }
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      getReports () {
        axios.get(`${window.API_URL}/reports?page=${this.currentPage}`)
          .then(({data}) => {
            this.reports = data.data
            this.totalPages = data.last_page
            this.isLoading = false
          })
      },

      prevReports () {
        if (this.currentPage > 1) {
          this.currentPage -= 1
          this.getReports()
        }
      },

      nextReports () {
        if (this.currentPage < this.totalPages) {
          this.currentPage += 1
          this.getReports()
        }
      },

      changePage (page) {
        this.currentPage = page
        this.getReports()
      },

      postForm () {
        this.validate()

        if (this.formValidate && !this.isLoading) {
          this.isLoading = true
          axios.post(`${window.API_URL}/reports`, this.form)
            .then((response) => {
              this.isShowModalConfirm = true
              this.isLoading = false
              // this.$refs.recaptcha.reset()
              this.currentDate = ''
              this.form = {
                dni: '',
                cellphone: '',
                title: '',
                date: '',
                detail: '',
                recaptcha: '',
                photo: {
                  base64: '',
                  extension: ''
                }
              }
              this.clearForm = !this.clearForm
            })
            .catch(({response}) => {
              this.isLoading = false
              this.isShowModalError = true
            })
        }
      },

      validate () {
        let validation = new Validator(this.form, this.rules)
        validation.passes()
        this.toggleValidate = !this.toggleValidate
        this.formValidate = validation.passes()
      },

      updateFile (image) {
        this.form.photo = image
      },

      onVerify (value) {
        this.form.recaptcha = value
      }
    },

    created () {
      this.getReports()
    },

    watch: {
      currentDate (val) {
        if (val) {
          this.form.date = val.format()
        } else {
          this.form.date = ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Reports/components/ReportsScreen.vue